import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, TransitionGroup as _TransitionGroup, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "notifications" }

import MainHeader from "@/components/MainHeader.vue";
import MainFooter from "@/components/MainFooter.vue";
import { useUserStore } from "@/stores/user";
import MobileNavBar from "@/components/MobileNavBar.vue";
import { detectMobile } from "@/helpers";
import { useAppStore } from "@/stores/app";
import MainNotification from "@/components/MainNotification.vue";
import AppLoader from "@/components/AppLoader.vue";
import { computed, ComputedRef } from "vue";
import router from "@/router";
import PopupAuth from "@/components/popups/PopupAuth.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const appStore = useAppStore();
const userStore = useUserStore();

const isMobile: boolean = detectMobile();

const isAuth: ComputedRef<boolean> = computed(() =>
  router.currentRoute.value.fullPath.includes("auth")
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_unref(appStore).firstLoading)
          ? (_openBlock(), _createBlock(AppLoader, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_TransitionGroup, { name: "fade" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appStore).notifications, (notification, index) => {
            return (_openBlock(), _createBlock(MainNotification, {
              key: index,
              notification: notification
            }, null, 8, ["notification"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createVNode(_Transition, { name: "popup" }, {
      default: _withCtx(() => [
        (isAuth.value)
          ? (_openBlock(), _createBlock(PopupAuth, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_TransitionGroup, { name: "popup" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appStore).popups, (popup, index) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent(popup.component), _mergeProps({ key: index }, popup.props), null, 16))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(MainHeader),
    _createVNode(_component_router_view),
    (!_unref(isMobile))
      ? (_openBlock(), _createBlock(MainFooter, { key: 0 }))
      : (_unref(userStore).isAuth)
        ? (_openBlock(), _createBlock(MobileNavBar, { key: 1 }))
        : _createCommentVNode("", true)
  ]))
}
}

})